import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "mb-24 mt-6" }
const _hoisted_3 = { class: "flex absolute" }
const _hoisted_4 = { class: "w-28 h-28" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col text-start items-start break-all w-36 gap-2" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "text-xs text-center line-through"
}
const _hoisted_10 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "tamanho:", -1)
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = { class: "flex justify-between gap-2 mt-8 pb-4 items-center" }
const _hoisted_14 = ["name"]
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RouterLink, {
        class: "flex flex-row items-center justify-between w-80",
        to: `/products/${_ctx.cartItem?.product_id}`,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _ctx.env + 'storage/' + _ctx.cartItem?.image,
                    class: "w-full h-full"
                  }, null, 8, _hoisted_5)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.cartItem.name_product), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format(_ctx.cartItem.price)), 1),
              (
                (_ctx.product.price_promotion != 0 && _ctx.product.price_promotion != undefined && _ctx.product.price_promotion != null) &&
                !Number.isNaN(_ctx.product.price_promotion)
              )
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                  minimumFractionDigits: 2,
                }).format(_ctx.product.price)), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.cartItem.size != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("p", null, _toDisplayString(_ctx.cartItem.size), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Icon, {
          icon: "mdi:trash-can-outline",
          class: "cursor-pointer hover:text-vermelho-lixeira text-xl",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeCartItem(_ctx.cartItem)))
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.color, (colors) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "h-2",
            key: colors.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colors.attributes, (color) => {
              return _withDirectives((_openBlock(), _createElementBlock("input", {
                key: color.id,
                type: "radio",
                name: 'productCart' + colors.id_product,
                style: _normalizeStyle({ backgroundColor: color.color }),
                class: "checked:border-2 checked:border-black",
                disabled: ""
              }, null, 12, _hoisted_14)), [
                [_vShow, color.id == _ctx.cartItem.color]
              ])
            }), 128))
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          type: "button",
          class: "font-semibold",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeQuantity(_ctx.cartItem, 'minus')))
        }, [
          _createVNode(_component_Icon, { icon: "mdi:minus" })
        ]),
        _createElementVNode("input", {
          class: "w-16 rounded bg-cinza-padrao/20 py-1 focus:outline-none text-center font-bold",
          value: _ctx.cartItem.quantity,
          disabled: ""
        }, null, 8, _hoisted_16),
        _createElementVNode("button", {
          type: "button",
          class: "font-semibold",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeQuantity(_ctx.cartItem, 'plus')))
        }, [
          _createVNode(_component_Icon, { icon: "mdi:plus" })
        ])
      ])
    ])
  ]))
}